import { render, staticRenderFns } from "./EditTeamMemberTeams.vue?vue&type=template&id=63e121a2&scoped=true"
import script from "./EditTeamMemberTeams.vue?vue&type=script&lang=ts"
export * from "./EditTeamMemberTeams.vue?vue&type=script&lang=ts"
import style0 from "./EditTeamMemberTeams.vue?vue&type=style&index=0&id=63e121a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e121a2",
  null
  
)

export default component.exports